/* eslint-disable @typescript-eslint/no-non-null-assertion */

export const config = {
  API_URL: process.env.REACT_APP_API_URL!,
  API_CALCULATOR_ID: process.env.REACT_APP_API_CALCULATOR_ID!,
  SEA_ROUTES_API_KEY: process.env.REACT_APP_SEA_ROUTES_API_KEY!,
  DICTIONARY_URL: process.env.REACT_APP_DICTIONARY_URL!,
};
